import React from 'react';
import styles from './CircularProgressGauge.module.css';

const CircularProgressGauge = ({ percentage, size = 120, strokeWidth = 12, label = 'Admission Chance' }) => {
  // Calculate the circle's properties
  const radius = (size - strokeWidth) / 2;
  const circumference = radius * 2 * Math.PI;
  const strokeDashoffset = circumference - (percentage / 100) * circumference;

  // Enhanced color scheme with softer colors and transparency
  const getColor = (percent) => {
    if (percent >= 80) return {
      primary: '#4CAF50',
      shadow: 'rgba(76, 175, 80, 0.25)',
      glow: 'rgba(76, 175, 80, 0.15)'
    };  // Green for high chance
    if (percent >= 40) return {
      primary: 'rgba(255, 152, 0, 0.85)', // Softer orange with transparency
      shadow: 'rgba(255, 152, 0, 0.20)',
      glow: 'rgba(255, 152, 0, 0.12)'
    };  // Softer orange for medium chance
    return {
      primary: '#F44336',
      shadow: 'rgba(244, 67, 54, 0.25)',
      glow: 'rgba(244, 67, 54, 0.15)'
    };  // Red for low chance
  };

  const colorScheme = getColor(percentage);

  return (
    <div className={styles.gaugeCard}>
      <div className={styles.gaugeContainer} style={{ width: size, height: size }}>
        <svg width={size} height={size}>
          {/* Enhanced background circle with subtle gradient */}
          <defs>
            <radialGradient id="backgroundGradient" cx="50%" cy="50%" r="50%">
              <stop offset="0%" style={{ stopColor: '#ffffff', stopOpacity: 1 }} />
              <stop offset="100%" style={{ stopColor: '#f8f9fa', stopOpacity: 1 }} />
            </radialGradient>
            <filter id="glow" x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow dx="0" dy="0" stdDeviation="3" floodColor={colorScheme.glow} floodOpacity="1"/>
            </filter>
            <filter id="softShadow" x="-50%" y="-50%" width="200%" height="200%">
              <feDropShadow dx="0" dy="2" stdDeviation="4" floodColor={colorScheme.shadow} floodOpacity="1"/>
            </filter>
          </defs>
          
          {/* Background circle */}
          <circle
            className={styles.backgroundCircle}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
          />
          
          {/* Progress circle with enhanced effects */}
          <circle
            className={styles.progressCircle}
            cx={size / 2}
            cy={size / 2}
            r={radius}
            strokeWidth={strokeWidth}
            style={{
              strokeDasharray: circumference,
              strokeDashoffset: strokeDashoffset,
              stroke: colorScheme.primary,
              filter: 'url(#softShadow) url(#glow)',
            }}
            transform={`rotate(-90 ${size / 2} ${size / 2})`}
          />
          
          {/* Percentage text with improved styling */}
          <text
            x="50%"
            y="50%"
            className={styles.percentageText}
            style={{
              fill: colorScheme.primary,
              fontSize: size * 0.28,
              filter: 'drop-shadow(0 1px 3px rgba(255, 255, 255, 0.8))'
            }}
          >
            {Math.round(percentage)}%
          </text>
        </svg>
      </div>
      <div className={styles.gaugeLabel}>{label}</div>
    </div>
  );
};

export default CircularProgressGauge; 